// extracted by mini-css-extract-plugin
module.exports = {"root":"AppearController_root__XtVso","hidden":"AppearController_hidden__20tD7"};